import classNames from 'classnames';
import { Field, useFormikContext } from 'formik';
import { storyblokEditable } from 'gatsby-source-storyblok';
import React, { useContext, useEffect } from 'react';
import { QuoteContext } from '../../../contexts/Quote';

interface StaticFormCheckboxProps {
  blok: {
    heading: string;
    checkbox_label: string;
    key: string;
  };
}

interface FormikContext {
  isSellAddressSameAsCustomerAddress: boolean;
  isRemortgageAddressSameAsCustomerAddress: boolean;
}

const StaticFormCheckbox: React.FC<StaticFormCheckboxProps> = ({ blok }) => {
  const { setFieldValue, errors, values } = useFormikContext<FormikContext>();
  const { quoteDetails } = useContext(QuoteContext);

  const applicableValue = () => {
    if (quoteDetails?.transactionType === 'Sell')
      return values?.isSellAddressSameAsCustomerAddress;
    if (quoteDetails?.transactionType === 'BuyAndSell')
      return values?.isSellAddressSameAsCustomerAddress;
    return values?.isRemortgageAddressSameAsCustomerAddress;
  };

  return (
    <div {...storyblokEditable(blok)}>
      <section
        className={classNames({
          '-mb-12': !applicableValue(),
        })}
      >
        {blok.heading && (
          <p className="font-dm-serif-display text-text/body text-2xl mb-6">
            {blok.heading}
          </p>
        )}
        <div className="flex items-center gap-x-3">
          <Field
            type="checkbox"
            name={blok.key}
            value={true}
            checked={applicableValue()}
            className={`focus:!ring-0 focus:!outline-none w-[18px] h-[18px] border-2 rounded-xs checked:border-button/primary-bg checked:bg-button/primary-bg text-button/primary-bg`}
          />
          <p className="text-sm text-text/body">{blok.checkbox_label}</p>
        </div>
      </section>
    </div>
  );
};

export default StaticFormCheckbox;
